module.exports = __webpack_public_path__ + "static/media/erth.7ae8b48b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Heading/img/erth.png
// module id = 678
// module chunks = 0